import { HttpResourceRef } from '@angular/common/http';
import { computed, Signal } from '@angular/core';

// Lecture d'API exposee aux composants. Contrairement a HttpResourceRef, value()
// ne leve pas quand la ressource est en erreur : elle vaut alors undefined, et
// l'erreur se lit dans error().
export interface ReadResource<T> {
  readonly value: Signal<T | undefined>;
  readonly error: Signal<unknown>;
  readonly isLoading: Signal<boolean>;
  hasValue(): boolean;
  reload(): boolean;
}

export function readResource<T>(ref: HttpResourceRef<T | undefined>): ReadResource<T> {
  return {
    value: computed(() => (ref.hasValue() ? ref.value() : undefined)),
    error: ref.error,
    isLoading: ref.isLoading,
    hasValue: () => ref.hasValue(),
    reload: () => ref.reload(),
  };
}
